exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#masterDataTypeManagement[data-v-67044343] .el-form--label-left .el-form-item__label{text-align:right}#masterDataTypeManagement .formHeight[data-v-67044343]{height:45px}#masterDataTypeManagement .titleBox[data-v-67044343]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}#masterDataTypeManagement .divider[data-v-67044343]{height:1px;border-bottom:1px solid #dcdcdc;-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);

// exports
